import { createContext, useState, useCallback, useMemo, useEffect } from "react";
import { STORAGE_SHARE_LINK_KEY, STORAGE_EMAIL_KEY } from "modules/storyblok/templates/ReferralTemplate/utils/consts";
import { useReferralProgramConfig } from "contexts/DataContext/hooks";
import type { UserContextProviderProps, UserContextProps } from "./UserContext.d";
import { updateStorageItem } from "./utils";

export const UserContext = createContext<UserContextProps | undefined>(undefined);

export const UserContextProvider = ({ children }: UserContextProviderProps) => {
  const [userEmail, setUserEmail] = useState("");
  const [shareLink, setShareLink] = useState("");

  const referralProgramConfig = useReferralProgramConfig();
  const { campaignSource } = referralProgramConfig;

  const fullStorageEmailKey = `${campaignSource}:${STORAGE_EMAIL_KEY}`;
  const fullStorageLinkKey = `${campaignSource}:${STORAGE_SHARE_LINK_KEY}`;

  useEffect(() => {
    const email = localStorage.getItem(fullStorageEmailKey) || "";
    const link = localStorage.getItem(fullStorageLinkKey) || "";

    setUserEmail(email);
    setShareLink(link);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateShareLink = useCallback((link: string) => {
    updateStorageItem(fullStorageLinkKey, link);
    setShareLink(link);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateEmail = useCallback((email: string) => {
    updateStorageItem(fullStorageEmailKey, email);
    setUserEmail(email);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const value = useMemo(
    () => ({
      updateShareLink,
      updateEmail,
      userEmail,
      shareLink,
      setUserEmail,
    }),
    [updateShareLink, updateEmail, userEmail, shareLink, setUserEmail]
  );

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};
